var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLinkedIn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#linked-in_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0A66C2",
  d: "M18.524 0H1.476A1.476 1.476 0 0 0 0 1.476v17.048A1.476 1.476 0 0 0 1.476 20h17.048A1.476 1.476 0 0 0 20 18.524V1.476A1.476 1.476 0 0 0 18.524 0M5.96 17.038H2.954V7.486h3.007zM4.456 6.163a1.726 1.726 0 1 1 1.736-1.726 1.702 1.702 0 0 1-1.736 1.725m12.588 10.883H14.04v-5.218c0-1.54-.654-2.014-1.499-2.014-.891 0-1.766.672-1.766 2.053v5.179H7.767V7.493h2.891v1.324h.04c.29-.588 1.306-1.592 2.858-1.592 1.677 0 3.49.996 3.49 3.912z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "linked-in_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgLinkedIn;